<!-- The contact form (owner 2026-10-12): the nav's Contact Us popover and the Contact Us page show this one form -->
<ng-container *ngIf="!sent">
  <div class="cp-head" *ngIf="head">
    <span class="cp-title">Contact Us</span>
    <span class="cp-sub">Tell us what you need and we will get back to you</span>
  </div>

  <form class="cp-form" [formGroup]="form" (ngSubmit)="onSubmit($event)" novalidate>
    <div class="cp-row">
      <label class="cp-field" [class.cp-error]="invalid('firstName')">
        <span class="cp-label">First Name</span>
        <input formControlName="firstName" type="text" placeholder="Jane" autocomplete="given-name"/>
      </label>
      <label class="cp-field" [class.cp-error]="invalid('lastName')">
        <span class="cp-label">Last Name</span>
        <input formControlName="lastName" type="text" placeholder="Doe" autocomplete="family-name"/>
      </label>
    </div>
    <label class="cp-field" [class.cp-error]="invalid('email')">
      <span class="cp-label">Email</span>
      <input formControlName="email" type="email" placeholder="jane.doe@example.com" autocomplete="email"/>
    </label>
    <label class="cp-field" [class.cp-error]="invalid('message')">
      <span class="cp-label">Message</span>
      <textarea formControlName="message" rows="5" maxlength="2000"
                placeholder="Your project, the theme you have in mind, your timeline"></textarea>
    </label>

    <p class="cp-message" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>

    <div class="cp-foot">
      <a class="cp-mail" [href]="'mailto:' + environmentCommon.company.email">{{ environmentCommon.company.email }}</a>
      <button type="submit" class="codigrate-button cp-send" [disabled]="sending"><p>{{ sending ? 'Sending' : 'Send' }}</p></button>
    </div>
  </form>
</ng-container>

<div class="cp-sent" *ngIf="sent" role="status">
  <svg class="cp-sent-icon" viewBox="0 0 64 44" fill="none" aria-hidden="true">
    <rect x="12" y="8" width="40" height="28" rx="4"></rect>
    <path d="M13 11 L32 26 L51 11"></path>
  </svg>
  <span class="cp-title">Message Sent</span>
  <span class="cp-sub">Thank you for reaching us. Our team will contact you soon.</span>
  <button type="button" class="codigrate-button cp-send" (click)="finish()"><p>Done</p></button>
</div>
